'use client'

import { getImageProps } from 'next/image'
import type { ImageProps } from 'next/image'
import styles from './CspImage.module.css'

/** Keep Next's optimizer/srcset without its serialized inline style attribute.
 * Use classes for layout. Blur placeholders need stateful removal and are not
 * supported by getImageProps; reject them at the type boundary, not silently.
 */
export type CspImageProps = Omit<ImageProps, 'style' | 'placeholder' | 'onLoadingComplete' | 'objectFit' | 'objectPosition'> & {
  style?: never
  placeholder?: 'empty'
}

export default function CspImage(input: CspImageProps) {
  const { props } = getImageProps(input)
  const { style: _inlineStyle, className, ...image } = props
  return (
    <>
      {(input.priority || input.preload) && (
        <link rel="preload" as="image" href={image.srcSet ? undefined : image.src}
          imageSrcSet={image.srcSet} imageSizes={image.sizes}
          crossOrigin={image.crossOrigin} referrerPolicy={image.referrerPolicy} />
      )}
      {/* Next's getImageProps retains URL validation, sizing, lazy loading and srcset. */}
      <img {...image} className={[input.fill ? styles.fill : '', className].filter(Boolean).join(' ')} />
    </>
  )
}
